import { MdInfo } from "react-icons/md";
import { Tooltip, TooltipText } from "./index.styled";

interface TooltipWarningProps {
  message: string;
  position?: "top" | "right" | "bottom" | "left";
  marginLeft?: string;
  backgroundColor?: string;
  borderColor?: string;
  color?: string;
}

const TooltipWarning: React.FC<TooltipWarningProps> = ({
  message,
  position = "top",
  marginLeft = "0px",
  backgroundColor,
  color,
  borderColor,
}) => {
  return (
    <Tooltip marginLeft={marginLeft}>
      <MdInfo />
      <TooltipText
        className="tooltipText"
        position={position}
        backgroundColor={backgroundColor}
        color={color}
        borderColor={borderColor}
      >
        {message}
      </TooltipText>
    </Tooltip>
  );
};

export default TooltipWarning;
